export const TOAST_CLIENT_ERROR_MESSAGE =
  'Hmm. Something went wrong. Please refresh the page and try again.';
